import Icon from 'core/components/icons/Icon'
import { Moment } from 'moment'

const MonthSwitcher = ({
  date,
  onChange
}: {
  date: Moment
  onChange: (date: Moment) => void
}) => {
  return (
    <div className="flex justify-center items-center gap-5 w-full">
      <Icon
        name="left"
        onClick={() => {
          const _date = date.clone()
          _date.subtract(1, 'month')
          onChange(_date)
        }}
        color="text-primary"
        width={20}
        height={20}
        className="hover:opacity-80 cursor-pointer select-none"
      />
      <p className="font-semibold w-24 text-center">
        {date.format('MMM YYYY')}
      </p>
      <Icon
        name="right"
        color="text-primary"
        width={20}
        height={20}
        className="hover:opacity-80 cursor-pointer select-none"
        onClick={() => {
          const _date = date.clone()
          _date.add(1, 'month')
          onChange(_date)
        }}
      />
    </div>
  )
}

export default MonthSwitcher
